// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutMain_root__2YjcS"};